
export enum StripeCouponNames {
    FREE_OF_CHARGE = "FREE_OF_CHARGE",
    OZ_FINANCIAL_EDUCATION_PROGRAMME = "OZ_FINANCIAL_EDUCATION_PROGRAMME",
    TRADERS_CIRCLE_MEMBER = "TRADERS_CIRCLE_MEMBER",
    BUNDLE_PLATFORM_BACKTESTING_TRADING_ALERTS = "BUNDLE_PLATFORM_BACKTESTING_TRADING_ALERTS"
}
